module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "bg-container"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "headline"
  }, [_c('p', {
    staticClass: "headTit"
  }, [_vm._v("服务内容")])]), _vm._v(" "), _c('div', {
    staticClass: "wp750"
  }, [_c('ul', {
    staticClass: "introduce"
  }, [_c('li', [_c('div', {
    staticClass: "icon01"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("求购信息")]), _vm._v(" "), _c('span', {
    staticClass: "con"
  }, [_vm._v("买家通过平台发布求购信息")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "icon02"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("货源信息")]), _vm._v(" "), _c('span', {
    staticClass: "con"
  }, [_vm._v("提供全面购买渠道货源信息")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "icon03"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("更多优选")]), _vm._v(" "), _c('span', {
    staticClass: "con"
  }, [_vm._v("货主通过平台发布货源信息")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "icon04"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("安全交易")]), _vm._v(" "), _c('span', {
    staticClass: "con"
  }, [_vm._v("第三方安全支付保障")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "icon05"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("今日报价")]), _vm._v(" "), _c('span', {
    staticClass: "con"
  }, [_vm._v("主要口岸各类木材实时报价")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "icon06"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("金融服务")]), _vm._v(" "), _c('span', {
    staticClass: "con"
  }, [_vm._v("仓单质押、进口开证、信用贷款")])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "second"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "headline"
  }, [_c('p', {
    staticClass: "headTit"
  }, [_vm._v("APP预览图")])]), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-16"
  }, [_c('img', {
    staticStyle: {
      "margin": "0 auto",
      "display": "block"
    },
    attrs: {
      "src": "/static/img/app/preview.png",
      "width": "80%",
      "height": "80%"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "headline"
  }, [_c('p', {
    staticClass: "head"
  }, [_c('img', {
    attrs: {
      "src": "static/img/app/logo.png",
      "width": "250",
      "height": "78"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_vm._v("下载渠道")]), _vm._v(" "), _c('p', {
    staticClass: "platform dividingLine"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flexiable"
  }, [_c('div', {
    staticClass: "downloadios"
  }, [_c('li', [_c('span', [_vm._v("iphone版")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('p', [_vm._v("通过苹果手机应用商店")]), _vm._v(" "), _c('p', [_vm._v("App Store搜索“木材码头”")])]), _vm._v(" "), _c('div', {
    staticClass: "downloadna"
  }, [_c('li', [_c('span', [_vm._v("安卓市场")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('p', [_vm._v("支持：华为、腾讯、小米、360、")]), _vm._v(" "), _c('p', [_vm._v("百度、安卓、安智、91助手、豌")]), _vm._v(" "), _c('p', [_vm._v("豆荚等应用市场。")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flexiable"
  }, [_c('div', {
    staticClass: "mar980"
  }, [_c('a', {
    staticClass: "downloadBtn",
    attrs: {
      "href": "http://app.emulian.com/"
    }
  }, [_vm._v("立即下载")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d4940386!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/app/HomeAppContent.vue
// module id = 174
// module chunks = 1